import { render, staticRenderFns } from "./clickUserWindow.vue?vue&type=template&id=3055f9bd&scoped=true&"
import script from "./clickUserWindow.vue?vue&type=script&lang=js&"
export * from "./clickUserWindow.vue?vue&type=script&lang=js&"
import style0 from "./clickUserWindow.vue?vue&type=style&index=0&id=3055f9bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3055f9bd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3055f9bd')) {
      api.createRecord('3055f9bd', component.options)
    } else {
      api.reload('3055f9bd', component.options)
    }
    module.hot.accept("./clickUserWindow.vue?vue&type=template&id=3055f9bd&scoped=true&", function () {
      api.rerender('3055f9bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/Ad/clickUserWindow.vue"
export default component.exports